import React, { FC } from 'react';
import { useData } from '../use-data';
import { HomeContactHTMLContent } from './home.styled';

const HomeContact: FC = () => {
  const {
    data: {
      home: { contactInfo },
    },
  } = useData();

  return contactInfo ? <HomeContactHTMLContent dangerouslySetInnerHTML={{ __html: contactInfo }} /> : null;
};

export default HomeContact;
